function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.473 8.473a4 4 0 10-4.946 0 6.666 6.666 0 00-4.147 5.454.67.67 0 001.333.146 5.333 5.333 0 0110.6 0 .667.667 0 00.667.594h.073a.667.667 0 00.587-.734 6.667 6.667 0 00-4.167-5.46zM8 8a2.667 2.667 0 110-5.333A2.667 2.667 0 018 8z"
});

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default SvgUser;